<ins-product-header [hasNoMinHeight]="true">
    <div class="product-header-image">
        <wuc-picture
            [imageDesktop]="knowledgeBaseItem?.image + '.webp'"
            [alt]="knowledgeBaseItem?.alt"
            [imageWidth]="{ desktop: 310 }"
            [imageHeight]="{ desktop: 220 }"
            [imageType]="'image/webp'"
        ></wuc-picture>
    </div>
    <div class="product-header-content">
        <h1 [innerHTML]="knowledgeBaseItem?.title"></h1>
        <ng-container *ngIf="knowledgeBaseItem?.summary; else summaryTemplate">
            <p class="intro-text" [innerHTML]="knowledgeBaseItem?.summary | sanitize"></p>
        </ng-container>
        <ng-content></ng-content>
    </div>
</ins-product-header>

<ng-template #summaryTemplate>
    <p class="intro-text"><ng-content select="[slot=intro]"></ng-content></p>
</ng-template>
